"use strict";

import Page from "./components/ListPropertyAdvancedRatesPage.jsx";

export const auth = true;
export const title = "i18n:advancedRateEditor.pageTitle";
export const Component = Page;
